<template>
  <div class="button-footer">
    <CButton variant="outline" name="save" color="primary" @click="back"
      >Back</CButton
    >
    <CButton
      variant="outline"
      v-show="!data.id"
      name="save"
      color="success"
      @click="save"
      :disabled="loading"
      ><CSpinner color="success" size="sm" variant="grow" v-show="loading" />
      Save</CButton
    >
    <CButton
      variant="outline"
      v-show="data.id"
      name="save"
      color="success"
      @click="update"
      :disabled="loading"
      ><CSpinner color="success" size="sm" variant="grow" v-show="loading" />
      Update</CButton
    >
  </div>
</template>
<script>
export default {
  props: ["data", "loading"],
  methods: {
    back() {
      this.$emit("back");
    },
    save() {
      this.$emit("save");
    },
    update() {
      this.$emit("update");
    },
  },
};
</script>